import Vue from "vue"
import VueI18n from "vue-i18n"
import frMessage from "./fr.json"
import enMessage from "./en.json"

Vue.use(VueI18n)

const messages = {
  fr: frMessage,
  en: enMessage,
}

const i18n = new VueI18n({
  locale: "fr",
  messages,
  fallbackLocale: "fr",
  silentFallbackWarn: true,
})

export default i18n
